<template>
  <v-card flat>
    <v-form lazy-validation>
      <v-container fluid grid-list-md>
        <v-layout wrap>
          <v-flex xs6>
            <v-layout wrap>
              <v-flex xs10>
                <v-text-field label="Advert name" v-model="advert.name" required></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-text-field label="Target URL" v-model="advert.url" required></v-text-field>
              </v-flex>
              <v-flex xs10>
                <v-switch label="Enabled" v-model="advert.enabled"></v-switch>
              </v-flex>
            </v-layout>
            <v-layout wrap>
              <v-flex xs8>
                <v-label>Advert Image <small>&mdash; should be 656x656</small></v-label>
                <image-upload
                  :url.sync="advert.image_url"
                  :path="'partner-images'"
                  :width="656"
                  :height="656"
                ></image-upload>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-divider class="my-5"></v-divider>
        <v-btn color="accent" @click.native="updateAdvert(advert)">Update</v-btn>
      </v-container>
    </v-form>
  </v-card>
</template>

<script>
import ImageUpload from '../Partners/ImageUpload';
import { mapActions } from 'vuex';
export default {
  name: 'Advert',
  components: { ImageUpload },
  props: ['advert'],
  data: () => ({
    tabs: null
  }),
  methods: mapActions(['updateAdvert'])
};
</script>

<style scoped></style>
